import Immutable from "seamless-immutable";
import * as types from "../actions/types";

const initialState = Immutable({
  auth: false,
  config: {
    STATIC_SERVER_URL: null,
  },
  loading: false,
  processing: {
    isProcessing: false,
  },
  admin: {},
  kol: {},
  company_admin: {},
  origin: "",
  selectedNft: {},
  isPollingApproveNftStatus: false,
  isPollingStakeStatus: false,
});

const appReducer = {
  app: (state = initialState, action) => {
    switch (action.type) {
      case types.SET_CONFIG: {
        // console.log(`config >> `, action.data);
        return { ...state, config: action.data };
      }
      case types.SET_AUTH:
        return { ...state, auth: action.data };
      case types.SET_LOADING:
        return { ...state, loading: action.data };
      case types.SET_PROCESSING:
        return { ...state, processing: action.data };
      case types.SET_ADMIN:
        if (!action.data || Object.keys(action.data).length === 0) {
          return {
            ...state,
            admin: initialState.admin,
          };
        }
        return { ...state, admin: action.data };
      case types.SET_ORIGIN:
        return { ...state, origin: action.data };
      case types.SET_IS_POLLING_APPROVE_NFT_STATUS:
        return { ...state, isPollingApproveNftStatus: action.data };
      case types.SET_IS_POLLING_STAKE_STATUS:
        return { ...state, isPollingStakeStatus: action.data };
      default:
        return state;
    }
  },
};

export default appReducer;
